var map = {
	"./Pattern01.png": "f669",
	"./Pattern02.png": "0f17",
	"./Pattern03.png": "7e45",
	"./Pattern04.png": "a0ee",
	"./Pattern05.png": "5829",
	"./Pattern06.png": "6cc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4c4";